
export enum UserRole {
  GYM = 'GYM',
  CLIENT = 'CLIENT'
}

export enum ReservationStatus {
  CONFIRMED = 'CONFIRMED',
  CHECKED_IN = 'CHECKED_IN',
  NO_SHOW = 'NO_SHOW',
  CANCELLED = 'CANCELLED'
}

export interface Zone {
  id: string;
  name: string;
}

export interface Gym {
  id: string;
  name: string;
  zoneId: string;
  address: string;
  description: string;
  capacityPerSlot: number;
  image: string;
}

export interface User {
  id: string;
  email: string;
  role: UserRole;
  name: string;
  gymId?: string; // If GYM
  homeGymId?: string; // If CLIENT
  homeZoneId?: string; // If CLIENT - Territorial protection
  benefitActive: boolean; // If CLIENT
  weeklyPassesUsed: number;
}

export interface Slot {
  id: string;
  gymId: string;
  dayOfWeek: number; // 0-6
  startTime: string; // HH:mm
  endTime: string;
  capacity: number;
  isActive: boolean;
}

export interface Reservation {
  id: string;
  clientId: string;
  gymId: string;
  slotId?: string | null;
  date: string; // YYYY-MM-DD
  status: ReservationStatus;
  qrCode: string;
  createdAt: string;
}

export interface ChatMessage {
  id: string;
  gymId: string;
  clientId: string;
  senderRole: UserRole;
  content: string;
  createdAt: string;
  isRead: boolean;
}
